window._ = require("lodash");
window.Popper = require("popper.js").default;

import "jquery-ui-bundle";
import "jquery-ui-bundle/jquery-ui.css";

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.$ = window.jQuery = require("jquery");

  require("bootstrap");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');
let isAuth = document.head.querySelector('meta[name="is-auth-user"]');
isAuth = +isAuth.content;

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token");
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

// import Echo from "laravel-echo"

// window.io = require('socket.io-client');

// if(isAuth && typeof io !== 'undefined'){
//     window.Echo = new Echo({
//         broadcaster: 'socket.io',
//         host: window.location.protocol + "//" + window.location.hostname
//     });
// }

window.realFloat = val => {
  let float = parseFloat(String(val).replace(/,/g, ""));
  return isNaN(float) ? 0 : float;
};

window.formatMoney = (val, skip_format) => {
  let money = realFloat(val);
  money = (Math.round(money.toFixed(3) * 100) / 100).toFixed(2);
  let cents = money.substring(money.indexOf("."), money.length);

  if (skip_format) {
    money = realFloat(money.substring(0, money.indexOf(".")));
  } else {
    money = realFloat(money.substring(0, money.indexOf("."))).format();
  }

  return money + cents;
};

window.findPeriods = (start, end) => {
  let start_date = moment(start, "MM/DD/YYYY");
  let end_date = moment(end, "MM/DD/YYYY");
  let range = [{ start_date, end_date }];

  // If still in same month + year
  if (start_date.isSame(end_date, "month")) {
    return range;
  }

  range = [];
  let diffMonths = end_date
    .clone()
    .endOf("month")
    .diff(start_date.clone().startOf("month"), "month");
  for (let i = 0; i <= diffMonths; i++) {
    let next_date = start_date
      .clone()
      .startOf("month")
      .add(1, "months");

    next_date = next_date.isAfter(end_date)
      ? end_date.clone()
      : next_date
          .clone()
          .subtract(1, "months")
          .endOf("month");

    let current_end_date = next_date;
    let current_start_date = start_date.isAfter(end_date) ? end_date.clone().startOf("month") : start_date;

    range.push({
      start_date: current_start_date,
      end_date: current_end_date
    });
    start_date = next_date
      .clone()
      .add(1, "month")
      .startOf("month");
  }

  return range;
};

window.findMonthPeriods = (start, end, fee = 0, isCorporate = false) => {
  let start_date = moment(start, "MM/DD/YYYY");
  let end_date = moment(end, "MM/DD/YYYY");
  let range = [];

  while (start_date.isSameOrBefore(end_date, "month")) {
    let month_start = start_date.clone().startOf("month");
    let month_end = start_date.clone().endOf("month");

    let period_start = start_date.isSame(month_start, "day") ? month_start : start_date;
    let period_end = start_date.isSame(end_date, "month") ? end_date : month_end;

    const fullPeriod = period_start.isSame(month_start, "day") && period_end.isSame(month_end, "day");
    const days = window.diffDays(period_start, period_end, isCorporate);

    range.push({
      name: start_date.format("MMMM YYYY"),
      start_date: period_start.format("MM/DD/YYYY"),
      end_date: period_end.format("MM/DD/YYYY"),
      amount: fullPeriod && !isCorporate ? fee : (fee / 30) * days
    });

    start_date = month_end.add(1, "day").startOf("day");
  }

  return range;
};

window.diffDays = (start_date, end_date, isCorporate) => {
  start_date = moment(start_date, "MM/DD/YYYY");
  end_date = moment(end_date, "MM/DD/YYYY");
  let diffDays = end_date.diff(start_date, "days") + 1;
  let checkForHalfMonth = !isCorporate;
  let actualDiffDays = isCorporate;

  // Check if the dates are valid or not
  if (!start_date.isValid() || !end_date.isValid() || start_date.isAfter(end_date)) {
    return 30;
  }

  // If it's February
  if (start_date.month() === 1) {
    // If need to check for half month value
    // and the diff days are 14, means = 15 (half of 30).
    if (checkForHalfMonth && diffDays === 14) {
      return 15;
    }

    // if diffDays = full month
    if (!actualDiffDays && diffDays === start_date.daysInMonth()) {
      return 30;
    }
  }

  // If the date has 31 days of a month
  if (start_date.daysInMonth() === 31) {
    // When actual diff days is false
    // and when diff days is 31
    if (!actualDiffDays && diffDays === 31) {
      return 30;
    }
  }

  return diffDays;
};

window.replaceTokens = (content, data = {}) => {
  const tokens = window.extractTokens(content);

  tokens.forEach(token => {
    const prop = window.getLastProperty(token);

    if (app_options[`${prop}s`]) {
      const option = app_options[`${prop}s`] ? app_options[`${prop}s`].find(opt => opt.id == window.getNestedValue(`${token}_id`)) : false;
      const value = option ? option.text : "";
      content = content.replaceAll(`{\{${token}\}}`, value);
    }
  });

  const template = Handlebars.compile(content);
  content = template(data);
  return content;
};
window.extractTokens = str => {
  const regex = /{\{([^{}]*)\}}/g;
  const matches = [];
  let match;

  while ((match = regex.exec(str)) !== null) {
    matches.push(match[1]);
  }

  return matches;
};
window.getNestedValue = dotNotation => {
  return dotNotation.split(".").reduce((o, key) => {
    return o && o[key] !== undefined ? o[key] : "";
  }, this);
};
window.getLastProperty = dotNotation => {
  const properties = dotNotation.split(".");
  return properties[properties.length - 1];
};

window.reinitCrmTable = (datatable, selector, type, contact_id) => {
  const table = $(`.adjuster_placements-card ${selector}`);
  if ($.fn.dataTable.isDataTable(table)) {
    table.DataTable().destroy();
    table.empty();
  }
  let html = "<thead><tr>";
  for (let i in datatable.header) {
    html += '<td data-column="' + i + '">' + datatable.header[i] + "</td>";
  }
  html += "</tr></thead>";
  table.html(html);
  table.data("post_data", {
    is_active: window.app_data.toggles[type].is_active,
    is_closed: window.app_data.toggles[type].is_closed,
    contact_id,
    include_placements_from_contacts: 1,
    [`${type}_only`]: 1
  });
  table.data("options", datatable.options);
  window.dataTableInstance(table);
};

window.urlParams = new URLSearchParams(window.location.search);

import Handlebars from "handlebars";

window.Handlebars = Handlebars;
Handlebars.registerHelper("choose", function(a, b) {
  return a ? a : b;
});
Handlebars.registerHelper("show_if", function(v1, condition, v2, options) {
  switch (condition) {
    case "greater_than":
      if (realFloat(v1) > realFloat(v2)) return options.fn(this);
      break;
    case "less_than":
      if (realFloat(v1) < realFloat(v2)) return options.fn(this);
      break;
    case "equal":
      if (v1 == v2) return options.fn(this);
      break;
    case "not_equal":
      if (v1 != v2) return options.fn(this);
      break;
    default:
      break;
  }

  return options.inverse(this);
});
Handlebars.registerHelper("full_name", function(name) {
  if (!name) return "";

  let [lastName, firstName] = name
    .replace(/[^a-z\- ,()]/gi, "")
    .replace(", ", ",")
    .split(",");
  lastName = lastName ? lastName.trim() : null;
  firstName = firstName ? firstName.trim() : null;
  const fullName = firstName ? `${firstName} ${lastName}` : lastName;
  return fullName;
});
Handlebars.registerHelper("first_name", function(name) {
  if (!name) return "";

  let [lastName, firstName] = name
    .replace(/[^a-z\- ,()]/gi, "")
    .replace(", ", ",")
    .split(",");
  lastName = lastName ? lastName.trim() : null;
  firstName = firstName ? firstName.trim() : null;
  return firstName;
});
Handlebars.registerHelper("is_float", function(value) {
  return window.realFloat(value) > 0;
});



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js